import { ServiceAlert } from './ServiceAlert';

export default ServiceAlert;
